import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileAvatorPostRequest } from '../types/CandidateProfile';

export default function usePostCandidateProfilesAvatar() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, file }: CandidateProfileAvatorPostRequest) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`/agent/api/candidate_profiles/${candidateProfileId}/avatar`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': token,
        },
        body: formData,
      });
      const data = await response.json();
      return data;
    },
  });
}
